import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
const ToolbarImageEditIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={32}
        height={32}
        fill="none"
        viewBox="0 0 32 32"
        className="Icon toolbar-image-edit"
        {...props}
    >
        <g fill="none" fillRule="evenodd">
            <rect width={32} height={32} fill="#1B2536" rx={4} />
            <g transform="translate(6.833 6.375)">
                <path
                    className="decoration"
                    fill="none"
                    stroke="#48505E"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={1.5}
                    d="M7.15 8.708H2.75v4.4c0 1.027 0 1.54.2 1.932.176.346.456.626.801.802.392.2.906.2 1.932.2h4.4v-4.4c0-1.027 0-1.54-.2-1.933a1.833 1.833 0 0 0-.801-.801c-.392-.2-.905-.2-1.932-.2ZM17.417 9.625V5.958a3.667 3.667 0 0 0-3.667-3.666h-3.667M12.375 0l-2.292 2.292 2.292 2.291M0 8.708h2.75v-2.75m7.333 12.834v-2.75h2.75"
                />
            </g>
        </g>
    </svg>
);
const Memo = memo(ToolbarImageEditIcon);
export default Memo;
